export default __webpack_public_path__ + "static/media/ox.63bb269c.svg";